var widgetList = {
	'the-milestone-referral' : {
		'Form Widget' : 'embedForm',
		'Milestone Widget' : 'milestoneWidget',
		'Referral Count Widget' : 'referralCountWidget'
	},
	'refer-a-friend' : {
		'Form Widget' : 'embedForm',
		'Reward Stats' : 'rewardStats'
	},
	'the-leaderboard-giveaway' : {
		'Popup Trigger' : 'popupTrigger'
	},
	'the-tempting-giveaway' : {
		'Popup Trigger' : 'popupTrigger'
	},
	'the-startup-pre-launch' : {
		'Popup Trigger' : 'popupTrigger'
	},
	'the-ecommerce-referral' : {},
	'online-to-offline' : {}	
}


export { widgetList };